import { AxiosAdapter } from '../commons/adapters';

const http = new AxiosAdapter();

export const createShiftDemandService = async (payload: any) => {
  return await http.postLogin<any>('/v1/shift-demands', payload);
};

export const createPlanningShiftRequestService = async (payload: any) => {
  return await http.postLogin<any>('/v1/planning-shift-requests', payload);
};

export const getShiftDemandsService = async (page: number, take: number, param?: string) => {
  return await http.get<any>(
    `/v1/planning-shift-requests?page=${page}&take=${take}${param ? `&${param}` : ''}`
  );
};
export const getPlanningShiftRequestByIdService = async (id: string) => {
  return await http.get<any>(`/v1/planning-shift-requests/${id}`);
};

export const updatePlanningShiftRequestService = async (id: string, payload: any) => {
  return await http.put<any>(`/v1/planning-shift-requests/${id}`, payload);
};
export const getDataRequerimientoPersonalCreateService = async () => {
  try {
    return await http.get<any>(`/v1/planning-shift-requests/form`);
  } catch (error: any) {
    if (error && !error.ok) return error;
    console.error('getDataRequerimientoPersonalCreateService error', error);
  }
};

export const updateShiftDemandService = async (id: string, payload: any) => {
  return await http.put<any>(`/v1/shift-demands/${id}`, payload);
};

export const deleteShiftDemandService = async (id: string) => {
  return await http.delete<any>(`/v1/planning-shift-requests/${id}`);
};

export const restoreShiftDemandService = async (id: string) => {
  return await http.patchTable<any>(`/v1/planning-shift-requests/${id}/restore`);
};
